module.exports = __webpack_public_path__ + "media/images/offer-634762eb2b28f25958b86abfddf59cb3.png";